import React from 'react';
import Slider from 'react-slick';
import UCIUruguayasLogoImage from '../../assets/images/records/record_uci-uruguayas.png';
import UTIsBrasileirasLogoImage from '../../assets/images/records/record_uti-brasileiras.png';
import AnzicsLogoImage from '../../assets/images/records/record_anzics.png';
import NICELogoImage from '../../assets/images/records/record_nice.png';
import CritCareAsiaLogoImage from '../../assets/images/records/record_crit-care-asia.png';
// import MICALogoImage from '../../assets/images/records/record_mica.png';
import CubreaLogoImage from '../../assets/images/records/record_cubrea.png';
import SATIQLogoImage from '../../assets/images/records/record_satiq.png';
import JipadLogoImage from '../../assets/images/records/record_jipad.png';
import IRISLogoImage from '../../assets/images/records/record_iris.png';
import AlbertaCriticalCareLogoImage from '../../assets/images/records/record_alberta-critical-care.png';
import './styles.scss';

const EpSponsorsSlider = () => {
  const sliderSettings = {
    dots: false,
    infinite: true,
    lazyLoad: true,
    pauseOnHover: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...sliderSettings}>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="http://www.ucisuruguayas.com.uy/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={UCIUruguayasLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="http://utisbrasileiras.com/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={UTIsBrasileirasLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://www.anzics.com.au/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={AnzicsLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://www.stichting-nice.nl/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={NICELogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://nicst.com/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={CritCareAsiaLogoImage} alt="" />
          </a>
        </div>
        {/* <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="http://www.micaproject.be/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={MICALogoImage} alt="" />
          </a>
        </div> */}
        <div className="slick-slide__item">
          {/* Confirme confirmado com o Jorge Salluh, o CUB-REA não tem site disponível  */}
          <a className="slick-slide__item-link" target="_blank">
            <img className="slick-slide__item-link-image" src={CubreaLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://www.satiq.net.ar/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={SATIQLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://www.jipad.org/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={JipadLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="http://www.irisicuregistry.org/" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={IRISLogoImage} alt="" />
          </a>
        </div>
        <div className="slick-slide__item">
          <a className="slick-slide__item-link" href="https://www.ualberta.ca/critical-care" target="_blank" rel="noopener noreferrer">
            <img className="slick-slide__item-link-image" src={AlbertaCriticalCareLogoImage} alt="" />
          </a>
        </div>
      </Slider>
    </div>
  );
};

export default EpSponsorsSlider;
